<template>
    <div class="category-card" :class="{ 'category-card__active': isCurrent }" @click="onClick">
        <div class="category-card__thumbnail-wrap">
            <el-image class="category-card__thumbnail" :src="thumbnail"></el-image>
            <div class="opt-btn-group">
                <i class="el-icon-download icon-delete" @click.stop="handleDownloadClick"></i>
                <i class="el-icon-delete icon-delete"  v-if="showDelete" @click.stop="handleDeleteClick"></i>
            </div>
            <div v-if="category.code" class="category-card__code">{{ category.code }}</div>
        </div>
        <template v-if="isCurrent">
            <Annotation
                v-for="(annotation, listIndex) in category.annotations"
                :key="listIndex + '-annotation'"
                :simplify="simplify"
                :annotation="annotation"
                :current="current.annotation"
                @click="onAnnotationClick(listIndex)"
                @keypoint-click="onKeypointClick(listIndex, $event)"
                @keypoints-complete="$emit('keypoints-complete')"
                :opacity="opacity"
                :index="listIndex"
                :keypoint-edges="keypoint.edges"
                :keypoint-labels="keypoint.labels"
                :keypoint-colors="keypoint.colors"
                ref="annotation"
                :hover="hover.annotation"
                :active-tool="activeTool"
                :scale="scale"
            />
        </template>
    </div>
</template>

<script>
import Annotation from './Annotation.vue';

export default {
    name: 'Category',
    components: { Annotation },
    props: {
        category: {
            type: Object,
            required: true,
        },
        simplify: {
            type: Number,
            default: 1,
        },
        activeTool: {
            type: String,
            required: true,
        },
        scale: {
            type: Number,
            default: 1,
        },
        opacity: {
            type: Number,
            default: 0.5,
        },
        index: {
            type: Number,
            required: true,
        },
        current: {
            type: Object,
            required: true,
        },
        hover: {
            type: Object,
            required: true,
        },
        showDelete: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            keypoint: {
                labels: [],
                edges: [],
                colors: [],
            },
        };
    },
    computed: {
        isCurrent() {
            return this.current.category === this.index;
        },
        thumbnail() {
            let src = '';
            if (this.category) {
                src = this.category.thumbnail || '';
                let dataType = this.category.dataType;
                if (!src) {
                    let images = this.category.images || [];
                    // let thumbImg = images[0] || '';
                    let thumbImg = '';
                    for (let i = 0; i < images.length; i++) {
                        let img = images[i];

                        // eslint-disable-next-line eqeqeq
                        if (dataType == 2) {
                            // 图片标注时
                            if (this.category.dataId === img.dataId) {
                                thumbImg = img;
                                // console.log(img);
                                break;
                            }
                        } else if (img.thumbnail) {
                            thumbImg = img;
                            break;
                        }
                    }
                    if (thumbImg) {
                        src = thumbImg.thumbnail;
                    }
                }
            }
            return src;
        },
    },
    methods: {
        onClick() {
            this.$emit('click');
        },
        handleDeleteClick() {
            this.$emit('delete');
        },
        handleDownloadClick() {
            this.$emit('download');
        },
        updateAnnotations() {
            this.$nextTick(() => {
                if (this.$refs.annotation) {
                    this.$refs.annotation.forEach((annotation) => {
                        annotation.initAnnotation();
                    });
                }
            });
        },
        onAnnotationClick() {},
        onKeypointClick() {},
        /**
         * @returns {Annotation} returns annotation and provided index
         */
        getAnnotation(index) {
            let ref = this.$refs.annotation;

            if (ref == null) return null;
            return this.$refs.annotation[index];
        },
        export() {
            let categoryData = {
                ...this.category,
                annotations: [],
            };
            if (this.$refs.annotation) {
                this.$refs.annotation.forEach((annotation) => {
                    categoryData.annotations.push(annotation.export());
                });
            }
            // console.log(categoryData);
            return categoryData;
        },
    },
    created() {},
    mounted() {},
    watch: {
        category: {
            handler(newVla) {
                // console.log('category', newVla);
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.category-card {
    /* display: inline-block; */
    height: inherit;
    width: inherit;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    .opt-btn-group {
        position: absolute;
        top: 3px;
        right: 3px;
        background: rgba(3, 5, 61, 0.5);

        padding: 2px;
        .icon-delete {
            cursor: pointer;
        }
    }
    .category-card__code {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 25px;
        line-height: 25px;
        text-align: center;
        background: rgba(46, 125, 248, 0.5);
        // color: #ffffff;
        font-size: 14px;
    }
}
.category-card + .category-card {
    margin-left: 16px;
}
.category-card__thumbnail {
    &-wrap {
        position: relative;
    }
    height: 114px;
    // width: 120px;
    width: 100%;
}
.category-card__active .category-card__thumbnail::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 3px solid #2e7df8;
    transition: all 0.3s;
}
</style>
